export default "__VITE_ASSET__jKlqxU9W__ 55w, __VITE_ASSET__IY_ZjsU3__ 110w, __VITE_ASSET__CAIkLXPB__ 220w";